import { Link } from 'components'
import React from 'react'

import { HashtagIcon, MailIcon } from '@heroicons/react/solid'

const ContactUs = () => {
  return (
    <div className="m-auto flex items-start justify-center py-12 px-4 flex-col">
      <h1 className="text-5xl text-white font-bold flex-1 mb-8">
        Got A <div className="text-primary inline">Question</div>? <br />
        Contact Us:
      </h1>

      <div className="flex flex-col">
        <div className="flex items-center mb-4 text-xl">
          <MailIcon className="w-6 h-6 text-white mr-1" />
          <Link
            href="mailto:support@devsnest.in"
            className="text-white hover:text-blue-300 transition-colors">
            support@devsnest.in
          </Link>
        </div>

        <div className="flex items-center mb-3 text-xl">
          <HashtagIcon className="w-6 h-6 text-white mr-1" />
          <span>282, GH-14, Paschim Vihar, New Delhi - 110063</span>
        </div>
      </div>
    </div>
  )
}

ContactUs.seo = {
  title: 'Contact Us | Devsnest',
  description: `Any questions or problems? No worries. Simply reach out to support@devsnest.in, and we'll do our best to respond to you right away.`,
  canonical: 'https://devsnest.in/contact-us',
  openGraph: {
    url: 'https://devsnest.in/contact-us'
  }
}

export default ContactUs
